import axios from '@/components/api/axios';

async function getBalance() {
  const res = await axios.axiosGet('/api/wallet/getBalance', null);
  return res;
}

async function getCashFlow(fromDate, page, toDate, walletAmountType) {
  let data = {
    fromDate: fromDate,
    page: page,
    toDate: toDate,
    walletAmountType: walletAmountType,
  }
  const res = await axios.axiosGet('/api/wallet/getCashFlow', data);
  return res;
}

async function getSalesSummaryDetailDaily(affiliateProductId, targetYmd) {
  let data = {
    affiliateProductId: affiliateProductId,
    targetYmd: targetYmd
  }
  const res = await axios.axiosGet('/api/wallet/getSalesSummaryDetailDaily', data);
  return res;
}

async function getSalesSummaryDetailMonthly(affiliateProductId, targetYm) {
  let data = {
    affiliateProductId: affiliateProductId,
    targetYm: targetYm,
  }
  const res = await axios.axiosGet('/api/wallet/getSalesSummaryDetailMonthly', data);
  return res;
}

async function getSalesSummaryReport(targetYm) {
  let data = {
    targetYm: targetYm
  };
  const res = await axios.axiosGet('/api/wallet/getSalesSummaryReport', data);
  return res;
}

async function getWithdrawInfo() {
  const res = await axios.axiosGet('/api/wallet/getWithdrawInfo', null);
  return res;
}

async function withdraw(amount, transferWithBonus) {
  let data = {
    amount: amount,
    transferWithBonus: transferWithBonus
  }
  console.log(data);
  const res = await axios.axiosPut('/api/wallet/withdraw', data);
  return res;
}

async function getNdsLpUrl(targetYm) {
  let data = {
    targetYm: targetYm
  }
  console.log(data);
  const res = await axios.axiosGet('/api/wallet/getNdsLpUrl', data);
  return res;
}


export default {
  getBalance,
  getCashFlow,
  getSalesSummaryDetailDaily,
  getSalesSummaryDetailMonthly,
  getSalesSummaryReport,
  getWithdrawInfo,
  withdraw,
  getNdsLpUrl
}



// WEBPACK FOOTER //
// ./src/components/api/wallet/wallet.js